'use client';

import FaIcon, { faClock } from '@/components/icon/FaIcon/FaIcon';
import ImageView from '@/components/ui/ImageView/ImageView';
import ScrollFade from '@/components/ui/ScrollFade/ScrollFade';
import { Format } from '@/lib/dateFns';
import { montserrat } from '@/lib/font';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { isPeriod, newDate } from '@/utils/date';
import { formatDateCommon } from '@/utils/formatters';
import type { LotteryWChance } from '@monorepo/common';
import { isAfter } from 'date-fns';
import { useGoodsModalAtom } from '../LotteryGoodsModal/LotteryGoodsModal';
import styles from './LotteryWChanceList.module.scss';

function LotteryWChanceList({
  wChanceList,
}: {
  wChanceList: Array<LotteryWChance>;
}) {
  const [_goodsModal, setGoodsModal] = useGoodsModalAtom();
  const openGoodsModal = (e: React.MouseEvent, goods: LotteryWChance) => {
    e.preventDefault();
    setGoodsModal({
      id: goods.id,
      isOpen: true,
      imageUrl: goods.imageUrl,
      name: goods.name,
      isGot: false,
    });
  };

  const lastWChanceId = wChanceList[wChanceList.length - 1].id;
  return (
    <div className={styles.wchanceContainer}>
      <ScrollFade tag={'div'}>
        <div className={styles.headerWrapper}>
          <span className={montserrat.className}>W</span>
          <small>チャンス賞</small>
        </div>
        <ul>
          {wChanceList.map((wChance) => (
            <li className={styles.itemCard} key={`wchance_${wChance.id}`}>
              {isAfter(newDate(), newDate(wChance.endAt)) && (
                <div className={styles.itemEndlabel}>
                  <p>終了しました</p>
                </div>
              )}
              <div
                className={`${styles.itemFilter} ${
                  !isPeriod(wChance.startAt, wChance.endAt) ? styles.itemOpacity : ''
                } ${lastWChanceId === wChance.id ? styles.lastItem : ''}`}
              >
                <div className={styles.itemContainer}>
                  {wChance.startAt && (
                    <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>
                      <FaIcon icon={faClock} size={'lg'} />
                      &nbsp;
                      {formatDateCommon(wChance.startAt, Format.dateTimeLotteryJa)}
                      &nbsp;〜&nbsp;
                      {formatDateCommon(wChance.endAt, Format.dateTimeLotteryJa)}
                    </p>
                  )}
                  <p className={`${styles.itemName} ${utilsStyles.textLarge} ${utilsStyles.textBold}`}>
                    {wChance.name}
                  </p>
                  {wChance.imageUrl && (
                    <div
                      className={`${utilsStyles.flexRowNowrap} ${utilsStyles.spaceBetween} ${styles.itemContentsMargin}`}
                    >
                      <div
                        className={styles.itemImage}
                        onClick={(e) => {
                          openGoodsModal(e, wChance);
                        }}
                      >
                        <ImageView src={wChance.imageUrl} alt='景品サムネイル' />
                      </div>
                      <p className={`${utilsStyles.darkColor} ${utilsStyles.textSmall} ${styles.itemDescription}`}>
                        {wChance.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </ScrollFade>
    </div>
  );
}

export default LotteryWChanceList;
